import React from 'react'
import { getCookie } from '../../utils';
import CONSTANT  from '../../constant';
import Login from './Login';

function SuperUser() {
   const user = getCookie(CONSTANT.cookie.userDetail);
  
   return <Login  />  

}

export default SuperUser
